import SvgIcon from '@elementor/ui/SvgIcon';
import PropTypes from 'prop-types';

const BoltStarIcon = ({ size = 25 }, props) => {
	return (
		<SvgIcon
			width="25"
			height="25"
			fill="none"
			viewBox="0 0 25 25"
			sx={{ fontSize: size }}
			{...props}
		>
			<path
				fill="#2847f3"
				fillRule="evenodd"
				d="M13.232 3.287A.75.75 0 0 1 13.75 4v6.25H19a.75.75 0 0 1 .607 1.191l-8 11a.75.75 0 0 1-1.357-.44v-6.25H5a.75.75 0 0 1-.607-1.192l8-11a.75.75 0 0 1 .839-.272"
				clipRule="evenodd"
			/>
			<path
				fill="#2847f3"
				d="M21.292 1c.452 0 .818.366.818.818a1.363 1.363 0 0 0 1.364 1.364.818.818 0 1 1 0 1.636 1.364 1.364 0 0 0-1.364 1.364.818.818 0 1 1-1.636 0 1.364 1.364 0 0 0-1.364-1.364.818.818 0 1 1 0-1.636 1.364 1.364 0 0 0 1.364-1.364c0-.452.366-.818.818-.818"
			/>
		</SvgIcon>
	);
};

BoltStarIcon.propTypes = {
	size: PropTypes.number,
};

export default BoltStarIcon;
